var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgReferral = function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#referral_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.871 12.116l.707-.707a5.006 5.006 0 017.071 0 5.008 5.008 0 010 7.07l-2.122 2.122a4.965 4.965 0 01-3.535 1.465 4.965 4.965 0 01-3.535-1.465l-.707-.707 1.414-1.414.707.707c1.133 1.133 3.109 1.133 4.242 0l2.122-2.121a3.005 3.005 0 000-4.243 3.007 3.007 0 00-4.243 0l-.707.707-1.414-1.414zm1.415 5.657c-1.133-1.133-3.109-1.133-4.242 0l-2.122 2.12a3.005 3.005 0 000 4.244 3.007 3.007 0 004.243 0l.707-.707 1.414 1.414-.707.707a4.983 4.983 0 01-3.536 1.462 4.983 4.983 0 01-3.535-1.462 5.008 5.008 0 010-7.071l2.122-2.121a4.965 4.965 0 013.535-1.465c1.336 0 2.592.52 3.535 1.465l.707.707-1.414 1.414-.707-.707z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "referral_svg__paint0_linear",
    x1: 5,
    y1: 31.5,
    x2: 29,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ECC71"
  })))));
};

export default SvgReferral;